import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { Row, Col, Button, Space, Rate, Typography } from "antd";
import { Link } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import { PiMoneyBold } from "react-icons/pi";
import { IoLocationSharp } from "react-icons/io5";
import { IoIosPeople } from "react-icons/io";
import { FaPeopleGroup } from "react-icons/fa6";
import { KEYS } from "../../../../Config/Keys";
import TeamRegisterModal from "./TeamRegisterModal";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import FadeInImage from "../../../../common/Images/FadeInImage";
import { GetTeamsOfOwner } from "../../../../Config/API/teams";
import Loader from "../../../../common/cards/Loader";
import useVariables from "../../../../common/hooks/useVariables";
import { Truncate } from "../../../../common/Text/Truncate";
import BookmarkEvent from "../../../../common/Buttons/BookmarkEvent";
import {
  EVENT_AND_TEAM_ROLES,
  EVENT_TYPES,
  GAMES_MODES,
  ROLES
} from "../../../../Config/helpers/constants";
import { GetEventWildCards } from "../../../../Config/API/events";
import WildCardRegistrationModal from "./WildCardRegistrationModal";
import {
  combineWildCardSlots,
  segregateEventAwardsAndReturnQuantity
} from "../../../../utils/utilityFunctions";
import useRating from "../../../../common/hooks/useRating";
import RatingModal from "../../../../common/Model/RatingModal";
import { GetPanelRatingsList } from "../../../../Config/API/panel";
import ViewRatings from "../../../../common/Model/ViewRatings";
import ShareModal from "../../../../common/Model/ShareModal";
import moment from "moment";
import { useCurrentPage } from "../../../../common/hooks/useCurrentPage";

const TopBar = ({ data, eventId, viewOnly, getEvent, panelFound, teamFound }) => {
  const [loading, setloading] = useState(false);
  const [open, setopen] = useState(false);
  const [remaining, setremaining] = useState(false);
  const [teamm, setTeams] = useState([]);
  const [rating, setRating] = useState(0);
  const [wildCardData, setWildCardData] = useState([]);
  const [wildCardModal, setWildCardModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { viewer } = useVariables();
  const registeredTeamsWithoutWildCards = data?.registerteams?.filter((team) => !team?.wildCard);
  const wildCardSlots = combineWildCardSlots(data?.wildCards);
  const { Text, Title } = Typography;

  const { isVisible, showRatingModal, comment, setComment, handleOk, handleCancel, ratingLoading } =
    useRating({
      defaultRating: 0,
      rating,
      setRating,
      eventId
    });

  const isPlayer = viewer?.flag === "player";
  const navigate = useNavigate();
  const { url } = useCurrentPage();

  const awards = useMemo(
    () => segregateEventAwardsAndReturnQuantity(data?.awardsDetail),
    [data?.awardsDetail]
  );

  useEffect(() => {
    setremaining(
      parseInt(data?.maxParicipants) - parseInt(registeredTeamsWithoutWildCards?.length)
    );
    if (isPlayer && !viewOnly) get();
  }, [data?.file?.file, data?.organizer?._id, isPlayer]);

  // get event wild card data
  useEffect(() => {
    const getEventWildCards = async () => {
      const res = await GetEventWildCards(eventId, "register");
      const response = await res.json();
      if (response?.type === "success" && response?.result?.length > 0) {
        setWildCardData(response?.result);
      }
    };

    if (!viewOnly) {
      getEventWildCards();
    }
  }, [eventId]);

  useEffect(() => {
    return () => {
      setTeams(null);
      setloading(null);
      setopen(null);
    };
  }, []);

  // check user has added ratings before in this event or not
  useEffect(() => {
    const getPanelRatings = async () => {
      const res = await GetPanelRatingsList(data?.panel?._id);
      const ratingData = await res.json();
      if (ratingData?.type === "success") {
        if (ratingData?.data?.length > 0) {
          // check if the current user has already rated this event
          const userDetails = localStorage.getItem("userDetails");
          const userId = userDetails ? JSON.parse(userDetails)?.id : "";
          const userRating = ratingData?.data?.find((rate) => rate?.userId === userId);
          if (userRating) {
            setRating(userRating?.rating);
          }
        }
      }
    };

    if (data?.panel?._id) {
      getPanelRatings();
    }
  }, [data?.panel?._id]);

  // team owner
  const checkowner = (t) => {
    const team = teamm?.find((e) => e._id === t);
    console.log(team);
    const id = viewer?.id;
    let isOwner = false;

    if (team?.members?.length > 0) {
      for (let i = 0; i < team.members.length; i++) {
        const element = team.members[i];
        if (element?.player?._id === id && element?.role === EVENT_AND_TEAM_ROLES.captain) {
          isOwner = true;
          break; // Stop the loop when isOwner becomes true
        } else {
          isOwner = false;
        }
      }
    } else {
      isOwner = true;
    }

    return isOwner;
  };
  // get teams of player
  const get = async () => {
    try {
      setloading(true);
      const id = viewer?.id;

      const res = await GetTeamsOfOwner({ id });
      let d = await res.json();
      d = d?.result;
      const filter = [];
      d.forEach((e) => {
        // let found = false;
        data?.registerteams?.forEach((r) => {
          if (e?._id === r?.team?._id) {
            // found = true;
            return;
          }
        });
        // if (!found) filter.push(e)
        filter.push(e);
      });
      setTeams(filter || []);
      setloading(false);
    } catch (e) {
      setloading(false);
      console.log(e.message);
    }
  };

  const openmodel = () => {
    if (remaining === 0) {
      return Swal.fire({
        icon: "info",
        text: "All slots are reserved!"
      });
    } else {
      setopen("register");
    }
  };

  // only captains of registered teams will be allowed to rate an event
  const checkAllowRating = () => {
    const registeredTeams = data?.registerteams;
    if (registeredTeams?.length > 0) {
      const playerTeam = registeredTeams?.find((team) =>
        team?.team?.members?.some((member) => member?.player === viewer?.id)
      );

      if (playerTeam && data?.complete) {
        return true;
      }

      return false;
    }

    return false;
  };
  const allowRating = useMemo(() => checkAllowRating(), [data?.registerteams]);

  const canregister = () => {
    const isFullSlots =
      data?.maxParicipants && registeredTeamsWithoutWildCards?.length === data?.maxParicipants;

    const cregister =
      new Date(data?.deadline).setHours(24) > new Date() &&
      data?.registrationComplete === false &&
      !isFullSlots;
    return cregister;
  };

  const PlayerButtons = () => {
    const isFullSlots =
      data?.maxParicipants && registeredTeamsWithoutWildCards?.length === data?.maxParicipants;
    return (
      <Col className="timelineemptyslots" lg={12} md={24} xs={24} sm={24}>
        <div className="EventPlayerButtons">
          {/* don't show register, schedule buttons on draft events */}
          {data?.draft || viewOnly ? null : (
            <div>
              {/* view awards button */}
              <Button
                style={{
                  borderRadius: "5rem",
                  width: "45%",
                  margin: "0"
                }}
                onClick={() => {
                  navigate(`/view/event/${eventId}/event-awards`);
                }}
                className="registerbutton btnMobileDimensions"
                type="primary">
                View Awards
              </Button>

              {data?.scheduleComplete && (
                <Button
                  style={{
                    borderRadius: "5rem",
                    width: "45%",
                    border: "none",
                    margin: "0",
                    background: "var(--blue)",
                    borderColor: "var(--blue)"
                  }}
                  className="registerbutton btnMobileDimensions"
                  type="primary"
                  onClick={() => {
                    if (data?.typeofmatch === "league") {
                      navigate(`/view/event/${eventId}/schedule`, { state: data });
                    } else if (
                      data?.typeofmatch === "ko" ||
                      data?.typeofmatch === "knockout" ||
                      data?.typeofmatch === "doubleelimination"
                    ) {
                      navigate(`/view/event/${eventId}/knock-out-matches`, { state: data });
                    } else if (data?.typeofmatch === GAMES_MODES.multi) {
                      navigate(`/view/event/${eventId}/multiplayermatches`, { state: data });
                    }
                  }}>
                  {isFullSlots ? "Schedule" : "Schedule"}
                </Button>
              )}
            </div>
          )}
          <Row justify="end">
            <BookmarkEvent />
          </Row>
        </div>
      </Col>
    );
  };

  return (
    <>
      <div className="profile-header">
        <div className="layout-width">
          {loading === "closing" ? <Loader fullpage /> : null}
          {/* <Row className="timelineTopbar"> */}

          <Row className="eventtoheader">
            <Col span={24}>
              <div className="banner-container banner-side-wrapper">
                <div className="banner-side left">
                  <div className="banner-mode">
                    <div className="mode-label">{data?.type ?? "tournament"}</div>
                    <img className="mode-tag" src="/images/tag.svg" />
                  </div>

                  <div className="banner-details">
                    <div className="detail-row">
                      <PiMoneyBold className="icon" size={28} />
                      {data?.fee}
                    </div>
                    <div className="detail-row">
                      <FaPeopleGroup className="icon" size={28} />
                      {data?.registerteams?.length} /{" "}
                      {(data?.maxParicipants || 0) + (wildCardSlots?.noOfSlots || 0)}
                    </div>
                  </div>

                  {canregister() && (
                    <div className="banner-deadline">
                      <Text className="deadline-label">Deadline:</Text>
                      <Text className="deadline-date">
                        {moment(data?.deadline).format("D-MMM-YYYY")}{" "}
                        {data?.type === EVENT_TYPES.SCRIM ? data?.deadlineTime : ""}
                      </Text>
                    </div>
                  )}

                  <div className="banner-button-group">
                    {canregister() ? (
                      <Button
                        type="primary"
                        size="large"
                        onClick={() => setShowModal(true)}
                        className="registerbutton btnMobileDimensions mb-2">
                        Registration Open
                      </Button>
                    ) : wildCardData?.length > 0 &&
                      wildCardSlots?.occupiedSlots < wildCardSlots?.noOfSlots ? (
                      <>
                        <Button
                          type="primary"
                          size="large"
                          className="registerbutton btnMobileDimensions mb-2 warning">
                          Registration Closed
                        </Button>
                        <Text className="wildcard-info">Wildcards entries are available</Text>
                        <Text className="wildcard-info" onClick={() => setWildCardModal(true)}>
                          Wild Card
                        </Text>
                      </>
                    ) : (
                      <Button
                        type="primary"
                        size="large"
                        className="registerbutton btnMobileDimensions mb-2 warning">
                        Registration Closed
                      </Button>
                    )}
                  </div>
                </div>

                <div className="banner-image-wrapper">
                  <FadeInImage
                    radius
                    preview
                    type="eventCover"
                    src={KEYS.API + data?.file?.fileUrl}
                  />
                </div>

                <div className="banner-side right">
                  <div className="banner-awards">
                    <Title level={3} className="section-title">
                      Awards:
                    </Title>

                    <div className="award-item award-item-b">
                      <img className="icon" height="42px" src="/images/icons/cash.svg" />
                      <span style={{ fontSize: "32px", fontWeight: "600" }}>
                        Rs. {awards?.cash || 0}
                      </span>
                    </div>

                    <div className="award-item">
                      <img className="icon" height="32px" src="/images/icons/certificate.svg" />
                      <span>{awards?.certificate || 0} Certificate(s)</span>
                    </div>

                    <div className="award-item">
                      <img className="icon" height="32px" src="/images/icons/shield.svg" />
                      <span>{awards?.shield || 0} Shield(s)</span>
                    </div>

                    <Text className="show-details">Show Details</Text>
                  </div>

                  <div className="banner-sponsors">
                    <Title level={3} className="section-title">
                      Sponsors:
                    </Title>
                    <div className="sponsor-logos">
                      <div className="sponsor-logo"></div>
                      <div className="sponsor-logo"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              className="timelinetopbarshadow"
              style={{ background: "whtie" }}
              lg={24}
              md={24}
              xs={24}
              sm={24}>
              <div className="timelinetopbarpadding">
                <Row justify="space-between">
                  <Col>
                    <Space>
                      <p className="timelinetopdata">
                        <FaCalendarAlt />
                        <span style={{ marginLeft: "5px" }}>
                          {moment(data?.startDate).format("MMM D, YYYY") + " - " + data?.type !==
                          EVENT_TYPES.SCRIM
                            ? moment(data?.endDate).format("MMM D, YYYY")
                            : null}
                        </span>
                      </p>
                    </Space>
                  </Col>
                  <Col>
                    {data?.nameofsports && (
                      <p className="timelinetoptype">
                        {data?.typeofsports} -{" "}
                        {data?.nameofsports?.charAt(0).toUpperCase() + data?.nameofsports?.slice(1)}
                      </p>
                    )}
                  </Col>
                </Row>
                <Row justify="space-between" alignItems="center">
                  <Col>
                    <div className="timelinefonttitle E_font ">
                      <Truncate text={data?.name} lines={2} level={4} />
                    </div>
                    <p className=" flexcenter">
                      <IoIosPeople style={{ fontSize: "1.2rem", color: "#6b6b6b" }} />
                      <span className="sideItemsText">
                        Organized by{" "}
                        <Link
                          state="panel"
                          to={`/view/panel/${data?.panel?._id}/timeline`}
                          style={{ color: "#0085ff", paddingRight: "0.5rem" }}>
                          {data?.panel?.name}
                        </Link>
                      </span>
                    </p>
                    {data?.type !== EVENT_TYPES.SCRIM && (
                      <p style={{ color: "#0FC5FF", display: "flex", alignItems: "center" }}>
                        <IoLocationSharp style={{ fontSize: "1rem" }} />
                        <span style={{ marginLeft: "5px", fontSize: "0.9rem", fontWeight: "500" }}>
                          {data?.city || "-"}
                        </span>
                      </p>
                    )}
                  </Col>
                  <Col className="toshare">
                    <Space
                      direction="vertical"
                      size="middle"
                      style={{ alignItems: "flex-end", rowGap: "0" }}>
                      <ShareModal relativeUrl={`/view/event/${eventId}`} />
                      <Space direction="horizontal" size="middles" align="center">
                        {allowRating && (
                          <>
                            <p style={{ fontWeight: "600" }} className="mr-2 mb-0 customratetitle">
                              Rating
                            </p>
                            <Rate
                              style={{ fontSize: "0.5rem", color: "#FF8E1E" }}
                              disabled={rating > 0}
                              className="custom-rate"
                              allowHalf
                              value={rating}
                              defaultValue={0}
                              onChange={(e) => {
                                setRating(e);
                                showRatingModal();
                              }}
                            />
                          </>
                        )}
                      </Space>
                      <Space>
                        {data?.complete && <ViewRatings type={ROLES?.event} id={data?._id} />}
                      </Space>
                    </Space>
                  </Col>
                </Row>
                <Row justify="space-between">
                  <Col lg={12} md={14} xs={24} sm={24}>
                    <Row justify="space-between">
                      <Col lg={8} sm={8} xs={8} md={12}>
                        <p className="E_slot">
                          Max Slots :
                          <span className="timelineslotscolor">{data?.maxParicipants || 0}</span>
                        </p>
                      </Col>

                      <Col lg={8} sm={8} xs={8} md={12}>
                        <p className="E_slot">
                          Min Slots :
                          <span className="timelineslotscolor">{data?.minParicipants || 0}</span>
                        </p>
                      </Col>

                      <Col lg={8} sm={8} xs={8} md={12}>
                        {data?.type !== EVENT_TYPES.SCRIM && (
                          <p className="E_slot">
                            Total Wildcards :
                            <span className="timelineslotscolor">
                              {wildCardSlots?.noOfSlots || 0}
                            </span>
                          </p>
                        )}
                      </Col>

                      <Col lg={8} sm={8} xs={8} md={12}>
                        <p className="E_slot">
                          Occupied Slots:
                          <span className="timelineslotscolor">
                            {registeredTeamsWithoutWildCards?.length || 0}
                          </span>
                        </p>
                      </Col>

                      <Col lg={8} sm={8} xs={8} md={12}>
                        <p className="E_slot">
                          Remaining Slots :
                          <span className="timelineslotscolor">{remaining || 0}</span>
                        </p>
                      </Col>

                      <Col lg={8} sm={8} xs={8} md={12}>
                        <p className="E_slot">
                          Occupied Wild Slots :
                          <span className="timelineslotscolor">
                            {wildCardSlots?.occupiedSlots || 0}
                          </span>
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <PlayerButtons />
                </Row>
              </div>
            </Col>
            {showModal && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0, 0, 0, 0.2)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  zIndex: 2000
                }}
                onClick={() => setShowModal(false)}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    background: "#fff",
                    padding: "20px",
                    minWidth: "300px",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.3)"
                  }}>
                  <h3>Choose Registration</h3>
                  <button
                    style={{
                      background: "#0085ff",
                      color: "white",
                      border: "none",
                      padding: "10px 20px",
                      fontSize: "16px",
                      cursor: "pointer",
                      borderRadius: "2rem"
                    }}
                    onClick={() => {
                      openmodel();
                      setShowModal(false);
                    }}>
                    Normal Registration
                  </button>
                  {data?.type !== EVENT_TYPES.SCRIM && (
                    <button
                      style={{
                        background: "#02c171",
                        color: "white",
                        border: "none",
                        padding: "10px 20px",
                        fontSize: "16px",
                        cursor: "pointer",
                        borderRadius: "2rem"
                      }}
                      onClick={() => {
                        setWildCardModal(true);
                        setShowModal(false);
                      }}>
                      Wild Card Entry
                    </button>
                  )}
                </div>
              </div>
            )}
          </Row>

          <TeamRegisterModal
            data={teamm}
            open={open}
            setopen={setopen}
            loading={loading}
            checkowner={checkowner}
            eventId={eventId}
            setremaining={setremaining}
            setTeams={setTeams}
            teams={teamm}
            registerteams={data?.registerteams}
            getEvent={getEvent}
          />
          {/* Wild card registration modal */}
          {wildCardModal && (
            <WildCardRegistrationModal
              eventId={eventId}
              wildCards={wildCardData}
              open={wildCardModal}
              setOpen={setWildCardModal}
              teams={teamm}
            />
          )}
          <RatingModal
            isVisible={isVisible}
            handleCancel={handleCancel}
            handleOk={handleOk}
            comment={comment}
            setComment={setComment}
            setRating={setRating}
            rating={rating}
            ratingLoading={ratingLoading}
          />

          <Col xl={24} lg={24} md={17} sm={15} xs={24} className="header-tabs">
            <Row className="subnavLinks header-tabs-row">
              <Col className="tosubnavcenter">
                <Link to={`/view/event/${eventId}/timeline`}>
                  <p className={url === "timeline" ? "toactive" : null}> Timeline</p>
                </Link>
              </Col>
              {(panelFound || teamFound) && (
                <Col className="tosubnavcenter">
                  <Link to={`/view/event/${eventId}/announcements`}>
                    <p className={url === "announcements" ? "toactive" : null}> Announcements </p>
                  </Link>
                </Col>
              )}
              <Col className="tosubnavcenter">
                <Link to={`/view/event/${eventId}/about`}>
                  <p className={url === "about" ? "toactive" : null}>About</p>
                </Link>
              </Col>
              <Col className="tosubnavcenter">
                <Link to={`/view/event/${eventId}/registerteams`}>
                  <p className={url === "registerteams" ? "toactive" : null}>Registered Teams</p>
                </Link>
              </Col>
            </Row>
          </Col>
        </div>
      </div>
      <div className="layout-width">
        <Outlet />
      </div>
    </>
  );
};

export default TopBar;
